<template>
  <div class="jrsoft-process" style="margin-top:0px;">
    <div  class="buttonGroup" style="margin-top: 0px;margin-bottom: 0px;">
      <!--{{isApproval}}{{ifBackFirst}}{{isApply}}{{isCopy}}-->
      <!--<el-button-group>-->

      <el-button size="mini" v-if="this.defaultConfig.ifHasProcess && !isWorkflow && !isReadOnly && !isApproval && !isCopy  && !isApply" @click="submit(16)" type="primary">提交</el-button>
        <el-button size="mini" v-if="!isReadOnly && !isApproval && !isCopy  && !isApply" @click="submit(1)" type="primary">保存</el-button>
        <el-button size="mini" v-if="isApproval && !delegateTask" @click="submit(6)" type="primary">同意</el-button>
      <el-button size="mini" v-if="delegateTask" @click="submit(6)" type="primary">提交</el-button>
        <el-button size="mini" v-if="ifBackFirst || isCopy" @click="submit(6)" type="primary">{{isCopy?'已阅':'提交'}}</el-button>
        <el-button size="mini" v-if="isWorkflow && !isApply && !isApproval && !isRevocation  && !isCopy && !ifBackFirst" @click="submit(8)"
                   type="primary">{{isEndEvent?"办理完成":"提交"}}
        </el-button>
        <el-button size="mini" v-if="isApproval && !delegateTask" @click="submit(5)" type="danger">不同意</el-button>
        <el-button size="mini" v-if="isApproval && !delegateTask" @click="submit(11)" type="danger">驳回</el-button>
<!--      <el-button size="mini" v-if="isApproval && !delegateTask" @click="submit(17)" type="primary">同意并结束流程</el-button>-->
      <el-button size="mini" v-if="isApproval && ifToOther && !delegateTask" @click="submit(13)" type="primary">委派</el-button>
        <el-button size="mini" v-if="isApproval && ifToOther && !delegateTask" @click="submit(12)" type="primary">转办</el-button>
        <el-button size="mini" v-if="isApply || ifBackFirst " @click="submit(3)" type="primary">撤销</el-button>
        <el-button size="mini" v-if="isApply" @click="submit(4)" type="primary">催办</el-button>
      <el-button size="mini" v-if="isRevocation" @click="submit(18)" type="danger">撤回</el-button>
        <!-- <el-button type="warning" size="mini" @click="submit(9)">打印</el-button> -->
        <el-button type="primary" size="mini" @click="submit(10)">导出</el-button>
      <el-button v-if="this.defaultConfig.ifHasProcess && validUtil.isNotNull(this.procInstId)" type="primary" size="mini" @click="processMonitorVisible=true">审批记录</el-button>
      <el-button v-if="rollbackDataBtnVisible" type="danger" size="mini" @click="submit(-2)">反核销</el-button>
<!--      &#45;&#45;{{transferCopy}}-->
      <el-button size="mini" v-if="transferCopy" @click="transferCopyVisible=true" type="primary">抄送</el-button>
        <el-button type="info" size="mini" @click="model.parent.submit(0)">关闭</el-button>
      <!--</el-button-group>-->
    </div>


    <div v-if="isWorkflow && (activitiData.length>0 || isCopy)" style="padding-top: 0px;padding-bottom: 0px;background-color: white;">

      <!--<div class="boxs-1"  :style="{width:'95%',height:'80%',overflow: 'auto'}">-->
    <div v-if="isWorkflow">



      <div v-if="activitiData.length>0 && !delegateTask"
           style="background-color: rgb(228, 228, 228); height: 35px;line-height: 35px;padding-top: 0px;padding-left: 10px;margin-top: 10px;">
        <div style="float:left;margin-right:20px;">后续环节:</div>
        <div v-show="item.visible" v-for="(item,key) in activitiData" :key="key" @click="selected(item,activitiData);"
             style="float:left;margin-right:20px;">
          <img  class="select-img" src="../../../assets/administrationIcon/active.png" width="20px" v-show="item.selected"
               alt="">
          <img class="select-img" src="../../../assets/administrationIcon/defult.png" width="20px" v-show="!item.selected"
               alt=""><span style="margin-left:5px;margin-top:3px;">{{item.name}}</span><span style="margin-left: 5px;font-size: 10pt;color:#757575;" v-if="item.transition && item.transition !== item.name">({{item.transition}})</span>

        </div>
      </div>
      <!-- -&#45;&#45;{{ifShowProc && !delegateTask}}-->
      <el-row v-show="ifShowProc && !delegateTask" style="margin-bottom: 0px;">
        <div style="" v-show="item.selected" v-for="(item,key) in activitiData" :key="key">
          <div v-if="activitiData.length>1" style="padding:5px 10px 5px 10px;">
            "{{item.name}}"审批人
          </div>
          <div class="load">
            <ul style="margin-bottom:0px;">
              <li style="margin-top: 2px;">
                <ul style="overflow:hidden;">
                  <li
                    style="float:left;margin:5px 5px 5px 5px;margin-right: 10px;position:relative;text-align:left;width:43px;display: inline-block;"
                    v-for="procUser in item.procUsers" :key="procUser.id">
                    <div :title="procUser.procUserName">
                      <div>
                        <img style="width:43px;height:43px;" :src="procUser.picture" alt=""></div>
                      <div style="text-align:center; font-size: 10px;">
                        <el-tooltip class="item" effect="dark" :content="procUser.procUserName" placement="bottom">
                        <span>{{procUser.procUserName.length>3?procUser.procUserName.substring(procUser.procUserName.length-3,procUser.procUserName.length):procUser.procUserName}}</span>
                        </el-tooltip>
                      </div>
                    </div>
                    <i @click="removeProcUser(item,procUser,$event)" v-if="item.showProcUserDelete" class="changeDelete"
                       style="position:absolute;top:-3px;left:30px;background:#f00;width:20px;height:20px;font-size:14px;line-height:20px;border-radius:50%;color:#fff">&nbsp;X</i>
                  </li>
                  <li v-if="item.ifSelUser"
                      style="float:left;margin:5px 0px 17px 3px;position:relative;text-align:left;width:43px;display: inline-block;">
                    <div>
                      <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc;" @click="addProcUser(item)" aria-hidden="true">
                        <use xlink:href="#icon-tianjiarenyuan"></use>
                      </svg>
                      <!-- <img style="width:45px;height:45px;" @click="addProcUser()" src="../../assets/addPeople1.png"> -->
                    </div>
                  </li>
                  <li v-if="item.ifSelUser"
                      style="float:left;margin:5px 5px 17px 5px;position:relative;text-align:left;width:43px;display: inline-block;">
                    <div>
                      <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc;" @click="delProcUser(item)" aria-hidden="true">
                        <use xlink:href="#icon-shanchulianxiren"></use>
                      </svg>
                      <!-- <img style="width:45px;height:45px;" @click="delProcUser()" src="../../assets/removePeople1.png"> -->
                    </div>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
          <selectMember :selectMemberModels='procUserModel' ref="selectProcUser"></selectMember>
        </div>
      </el-row>
      <el-row v-show="ifShowCopy && !delegateTask" style="margin-bottom: 0px;">
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span style="text-align:left;">抄送人</span>
          </div>
        </div>
        <div class="load">
          <ul style="margin-bottom:0px;">
            <li style="margin-top: 2px;">
              <ul>
                <li style="float:left;margin:5px 5px 5px 5px;position:relative;text-align:left;"
                    v-for="user in copyUserModel.selectList" :key="user.id">
                  <div :title="user.userName">
                     <div>
                      <img style="width:43px;height:43px;" :src="user.picture || sessionUtil.getDefaultAvatar()" alt=""></div>
                    <div style="text-align:center; font-size: 10px;">
                      <el-tooltip class="item" effect="dark" :content="user.userName" placement="bottom">
                      <span>{{user.userName.length>3?user.userName.substring(user.userName.length-3,user.userName.length):user.userName}}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <i @click="removeCopyUser(user,$event)" v-if="showCopyUserDelete" class="changeDelete"
                     style="position:absolute;top:-6px;left:-5px;background:#f00;width:20px;height:20px;font-size:14px;line-height:20px;border-radius:50%;color:#fff">&nbsp;X</i>
                </li>
                <li v-if="ifSelCopy" style="float:left;margin:5px 0px 17px 3px;position:relative;text-align:left;">
                  <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc" @click="addCopyUser()" aria-hidden="true">
                    <use xlink:href="#icon-tianjiarenyuan"></use>
                  </svg>
                  <!-- <img style="width:45px;height:45px;" @click="addCopyUser()" src="../../assets/addPeople1.png"> -->
                </li>
                <li v-if="ifSelCopy" style="float:left;margin:5px 5px 17px 5px;position:relative;text-align:left;">
                  <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc" @click="delCopyUser()" aria-hidden="true">
                    <use xlink:href="#icon-shanchulianxiren"></use>
                  </svg>
                  <!-- <img style="width:45px;height:45px;" @click="delCopyUser()" src="../../assets/removePeople1.png"> -->
                </li>
              </ul>
            </li>

          </ul>
        </div>
        <selectMember :selectMemberModels='copyUserModel' ref="selectCopyUser"></selectMember>
      </el-row>
      <el-row v-if="(isWorkflow && !isReadOnly && validUtil.isNotNull(this.procDefId)) || (isCopy && validUtil.isNotNull(this.procDefId)) || ifBackFirst" style="margin-bottom: 0px;" :style="{'margin-top':isCopy?'10px':'0px'}">
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span style="text-align:left;">{{ifFirstNode? '申请说明' : (isCopy ? '审阅意见' : '审批意见')}}</span>  <el-select  size="mini" v-model="commentSelectValue" placeholder="--请选择--"  @change="newVal=>handlerCommentSelect(newVal)"  style="width:200px;margin-left: 10px;">
            <el-option v-for="(option,optionIndex) in commentOptions" :key="optionIndex" :label="option.name" :value="option.value"></el-option>
          </el-select> <i class="el-icon-setting" @click="handlerOpenCommentConfig()" style="cursor: pointer;font-size: 13pt;"></i>
          </div>
        </div>
        <div style="margin-top: 5px;margin-bottom:5px;">
          <el-input type="textarea" v-model="comment"></el-input>
        </div>
      </el-row>
      <!--{{JSON.stringify(uploadConfig)}}&#45;&#45;&#45;&#45;{{activitiData.length>0 && isApproval && uploadConfig.visible}}-->
      <el-row v-if="activitiData.length>0 && uploadConfig.visible" style="margin-bottom: 0px;">
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span style="text-align:left;">附件</span>
          </div>
        </div>
        <div style="margin-top: 5px;margin-bottom:5px;">
          <upload
            :config="uploadConfig"
            ref='uploading'
            style="padding-left: 10px;"
          ></upload>
        </div>
      </el-row>
    </div>

    <div v-if="showProcessMonitor" style="margin-top: 10px;">
      <!--流程监控-->
      <el-row>
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span  class="span-look" style="text-align:left;margin-left: 0px;" @click="procTaskVisible = !procTaskVisible">流转记录</span><span class="span-look" @click="openPng();" style="">查看流程图</span>
          </div>
        </div>
        <process-monitor  v-if="procTaskVisible" :model="processMonitorModel" ref="processMonitor" style="margin-top:10px;"></process-monitor>
      </el-row>
    </div>


    </div>

    <div>

      <div class="select-box" v-if="dialogSelProcVisible">
        <div class="select">
          <div class="title">
            <h4 style="margin:30px 22px 0;"><i></i>请选择流程</h4>

          </div>
          <div class="select-center">
            <ul>
              <li v-for="(item,key) in processList" :key="key" @click="selected(item,processList)"
                  style="border-bottom: dashed  1px rgb(235, 233, 233);">
                <p>{{item.name}}</p>
                <img class="select-img" src="../../../assets/administrationIcon/active.png" width="20px"
                     v-show="item.selected" alt="">
                <img class="select-img" src="../../../assets/administrationIcon/defult.png" width="20px"
                     v-show="!item.selected" alt="">
              </li>
            </ul>
          </div>
          <div class="footer">
            <button @click="submit(7)" class="button">提交</button>
            <button @click="closeSelDialog()">取消</button>
          </div>
        </div>
      </div>
    </div>
    <!--<el-dialog
      :title="pngTitle"
      :visible.sync="pngVisible"
      width="30%"
      height="50%"
      center>
      <div style="width:100%;height:500px;text-align: center;overflow: auto;">

        <img style="width:200px;" width='100%' :src="pngSrc"/>
      </div>

    </el-dialog>-->

    <div>
      <div class="select-box" v-if="pngVisible" @click.stop="pngVisible = !pngVisible">
        <div class="select" @click.stop="" style="width: 800px;height:620px;padding: 48px 20px 18px 20px;">
          <div class="title">
            <h4 style="margin:15px 22px 0;"><i></i>{{pngTitle}}</h4>
            <i  class="el-icon-close" @click.stop="pngVisible = !pngVisible" style="cursor: pointer; font-size: 20px;position: fixed; top: 15px;right: 15px;"></i>
          </div>
          <div class="select-center" style="height:550px;">
            <div  id="wf-png-previewer" style="width:100%;height:100%;text-align: center;overflow: auto;">

              <!--<img style="width:200px;" width='100%' :src="pngSrc"/>-->
              <el-image
                :style="{width: imageWidth, height: 'auto'}"
                :src="pngSrc"
                :preview-src-list="srcList">
              </el-image>
            </div>
          </div>

        </div>
      </div>
    </div>

    <el-dialog
      :title="assingeeDialogTitle"
      :visible.sync="assingeeDialogVisible"
      width="200"
      height="200"
      center>
      <div style="width:100%;height:205px;text-align: left;overflow: auto;">
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span style="text-align:left;">处理人</span>
          </div>
        </div>
        <select-user-cmp single :max="1" ref="select-user-cmp"></select-user-cmp>
        <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
          <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
            <span style="text-align:left;">审批意见</span>  <el-select  size="mini" v-model="commentSelectValue" placeholder="--请选择--"  @change="newVal=>handlerCommentSelect(newVal)"  style="width:200px;margin-left: 10px;">
            <el-option v-for="(option,optionIndex) in commentOptions" :key="optionIndex" :label="option.name" :value="option.value"></el-option>
          </el-select> <i class="el-icon-setting" @click="handlerOpenCommentConfig()" style="cursor: pointer;font-size: 13pt;"></i>
          </div>
        </div>
        <div style="margin-top: 5px;margin-bottom:5px;">
          <el-input type="textarea" v-model="comment"></el-input>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="assingeeDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="assingeeDialogVisible = false;submit(assigneeOperateType+2)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="审批记录"
      :visible.sync="processMonitorVisible"
      width="80%"
      height="500"
      :modal="false"
      center>
      <div style="width:100%;height:100%;max-height: 500px;text-align: left;overflow-y: auto;">
        <process-monitor  v-if="processMonitorVisible" :model="processMonitorModel" ref="processMonitorDialog" style="margin-top:10px;"></process-monitor>

      </div>
    </el-dialog>
    <el-dialog
      title="抄送"
      :visible.sync="transferCopyVisible"
      width="80%"
      height="500"
      :modal="false"
      center>
      <div style="width:100%;height:100%;max-height: 500px;text-align: left;overflow-y: auto;">

        <copy-form v-if="transferCopy" @handleCancel="transferCopyVisible=false"></copy-form>
      </div>
    </el-dialog>


  </div>

</template>
<script>
   // import {unwatchFile} from "fs";
  import {mixin} from './mixin.js'

  export default {
    name: 'ProcessForm',
    mixins: [mixin]

  };
</script>

<style scoped>
  .select-box {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
  }

  .select {
    position: absolute;
    z-index: 999;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 460px;
    height: 250px;
    overflow: hidden;
    padding: 68px 20px 58px 20px;
    box-sizing: border-box;
  }

  .select-center {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  h4 {
    color: #333;
    font-size: 18px;
    font-family: SourceHanSansCN-Medium;
    padding-left: 12px;
    position: relative;
    margin: 30px 0;
  }

  h4 i {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    height: 20px;
    width: 2px;
  }

  .select .title {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
  }

  .img-box img {
    width: 100%;
    margin-top: 4px;
  }

  .footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    left: 0;
  }

  .footer button {
    float: right;
    width: 60px;
    height: 28px;
    margin-right: 20px;
  }

  .select-center li {
    height: 37px;
    box-sizing: border-box;
    padding: 6.5px 0;
  }

  .select-center li p {
    float: left;
  }

  .select-center li img {
    float: left;
    margin-right: 8px;
  }

  .select-center li .select-img {
    float: right;
  }

  .button {
    background: rgb(92, 154, 212);
    color: rgb(255, 255, 255);
    border-color: rgb(92, 154, 212);
  }

  /* .buttonGroup {
      position: fixed;
      bottom: 16px;
      background: white;
      height: 50px;
      z-index: 100;
      right: 65px;
  } */
  .jrsoft-process {
    padding-bottom: 10px;
  }

  .jrsoft-process img {
    vertical-align: middle;
  }

  .btnClass button {
    height: 35px;
  }

  .span-look {
    margin-left: 20px;
    text-align: left;
    color: #3b8cff;
    cursor: pointer;
  }

  span.span-look:hover {
    color: #908c8c;
  }
  .boxs {
    width: 812px;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    height: 391px;
    z-index: 99;
    overflow: hidden;
    padding: 0 15px;
    display: flex;
    flex-flow: column;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/common/wf/v2/process-form.vue